import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { Hero } from '../lib/heroes';
import { AddHeroStep } from '../components/wizard/AddHeroStep';
import '../components/wizard/wizard.css';

export function HeroNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleSaved(hero: Hero) {
    navigate('/heroes', { state: { optimisticHero: hero } });
  }

  function handleCancel() {
    navigate('/heroes');
  }

  return (
    <>
      <header className="wizard-header">
        <span className="wizard-header__dots" aria-hidden="true" />
        <button type="button" className="wizard-header__cancel" onClick={handleCancel}>
          {t('common.cancel')}
        </button>
      </header>
      <div className="wizard-body">
        <div className="wizard-step-anim">
          <AddHeroStep onSaved={handleSaved} onCancel={handleCancel} />
        </div>
      </div>
    </>
  );
}
